const fpsQualityLevels = [
    { value: 60, text: 'Very smooth', className: 'very_smooth', fill: '#00df00' },
    { value: 45, text: 'Smooth', className: 'smooth', fill: '#71d001f0' },
    { value: 30, text: 'Playable', className: 'playable', fill: '#a9d001' },
    { value: 20, text: 'Borderline', className: 'borderline', fill: '#d0a301' },
    { value: 0, text: 'Unplayable', className: 'unplayable', fill: '#d01401' }
];

export function qualityCheck(value: number): { text: string; value: number | string; className: string; fill: string } {
    for (const key of fpsQualityLevels) {
        if (value >= key.value) return key;
    }
    return { text: 'Unplayable', value: 0, className: 'unplayable', fill: '#d01401' };
}
